import { render, staticRenderFns } from "./JsonField.vue?vue&type=template&id=143e2763&scoped=true&"
import script from "./JsonField.vue?vue&type=script&lang=js&"
export * from "./JsonField.vue?vue&type=script&lang=js&"
import style0 from "./JsonField.vue?vue&type=style&index=0&id=143e2763&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143e2763",
  null
  
)

export default component.exports